(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anuncio-superior"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE_SESION = 'anuncio-superior-cerrado';

  function iniciarAnuncio(seccion) {
    if (seccion.dataset.anuncioSuperiorIniciado === 'true') return;
    seccion.dataset.anuncioSuperiorIniciado = 'true';

    try {
      if (sessionStorage.getItem(CLAVE_SESION) === 'true') {
        seccion.classList.add('anuncio-superior-seccion--cerrado');
        return;
      }
    } catch (error) {
      // sessionStorage no disponible, se continúa sin persistencia
    }

    var mensajes = seccion.querySelectorAll('.anuncio-superior-mensaje');
    var botonCerrar = seccion.querySelector('.anuncio-superior-boton-cerrar');
    var velocidad = parseInt(seccion.dataset.velocidad, 10) || 4000;
    var indiceActual = 0;

    if (mensajes.length > 1) {
      setInterval(function () {
        mensajes[indiceActual].classList.remove('anuncio-superior-mensaje--activo');
        indiceActual = (indiceActual + 1) % mensajes.length;
        mensajes[indiceActual].classList.add('anuncio-superior-mensaje--activo');
      }, velocidad);
    }

    if (botonCerrar) {
      botonCerrar.addEventListener('click', function () {
        seccion.classList.add('anuncio-superior-seccion--cerrado');
        try {
          sessionStorage.setItem(CLAVE_SESION, 'true');
        } catch (error) {
          // sessionStorage no disponible, se cierra solo para esta carga
        }
      });
    }
  }

  function iniciarTodos() {
    document.querySelectorAll('.anuncio-superior-seccion').forEach(iniciarAnuncio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('.anuncio-superior-seccion');
    if (seccion) {
      seccion.dataset.anuncioSuperiorIniciado = 'false';
      iniciarAnuncio(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(seccion) {
    if (seccion.dataset.carruselProductosIniciado === 'true') return;
    seccion.dataset.carruselProductosIniciado = 'true';

    var pista = seccion.querySelector('.carrusel-productos-pista');
    var flechaAnterior = seccion.querySelector('.carrusel-productos-flecha--anterior');
    var flechaSiguiente = seccion.querySelector('.carrusel-productos-flecha--siguiente');

    if (!pista) return;

    function desplazar(direccion) {
      var tarjeta = pista.querySelector('.carrusel-productos-tarjeta');
      var ancho = tarjeta ? tarjeta.getBoundingClientRect().width + 16 : 200;
      pista.scrollBy({ left: direccion * ancho * 2, behavior: 'smooth' });
    }

    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }
  }

  function iniciarTodos() {
    document.querySelectorAll('.carrusel-productos-seccion').forEach(iniciarCarrusel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('.carrusel-productos-seccion');
    if (seccion) {
      seccion.dataset.carruselProductosIniciado = 'false';
      iniciarCarrusel(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-mio"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFooter(seccion) {
    if (seccion.dataset.footerCompletoIniciado === 'true') return;
    seccion.dataset.footerCompletoIniciado = 'true';

    var botonArriba = seccion.querySelector('[data-footer-volver-arriba]');
    if (botonArriba) {
      botonArriba.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  function iniciarTodos() {
    document.querySelectorAll('.footer-completo-seccion').forEach(iniciarFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('.footer-completo-seccion');
    if (seccion) {
      seccion.dataset.footerCompletoIniciado = 'false';
      iniciarFooter(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-edit"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarHeader(seccion) {
    if (seccion.dataset.headerPersonalizadoIniciado === 'true') return;
    seccion.dataset.headerPersonalizadoIniciado = 'true';

    var botonAbrirMenu = seccion.querySelector('[data-header-menu-abrir]');
    var botonCerrarMenu = seccion.querySelector('[data-header-menu-cerrar]');
    var menuMovil = seccion.querySelector('[data-header-menu-movil]');
    var overlay = seccion.querySelector('[data-header-overlay]');
    var botonAbrirBusqueda = seccion.querySelector('[data-header-buscar-abrir]');
    var botonCerrarBusqueda = seccion.querySelector('[data-header-buscar-cerrar]');
    var panelBusqueda = seccion.querySelector('[data-header-buscar-panel]');
    var inputBusqueda = seccion.querySelector('[data-header-buscar-input]');

    function abrirMenu() {
      if (!menuMovil || !overlay) return;
      menuMovil.hidden = false;
      overlay.hidden = false;
      botonAbrirMenu.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function cerrarMenu() {
      if (!menuMovil || !overlay) return;
      menuMovil.hidden = true;
      overlay.hidden = true;
      botonAbrirMenu.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (botonAbrirMenu) {
      botonAbrirMenu.addEventListener('click', abrirMenu);
    }
    if (botonCerrarMenu) {
      botonCerrarMenu.addEventListener('click', cerrarMenu);
    }
    if (overlay) {
      overlay.addEventListener('click', cerrarMenu);
    }

    if (botonAbrirBusqueda && panelBusqueda) {
      botonAbrirBusqueda.addEventListener('click', function () {
        var abierto = !panelBusqueda.hidden;
        panelBusqueda.hidden = abierto;
        if (!abierto && inputBusqueda) {
          inputBusqueda.focus();
        }
      });
    }

    if (botonCerrarBusqueda && panelBusqueda) {
      botonCerrarBusqueda.addEventListener('click', function () {
        panelBusqueda.hidden = true;
      });
    }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        cerrarMenu();
        if (panelBusqueda) panelBusqueda.hidden = true;
      }
    });
  }

  function iniciarTodos() {
    document.querySelectorAll('.header-personalizado-seccion').forEach(iniciarHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('.header-personalizado-seccion');
    if (seccion) {
      seccion.dataset.headerPersonalizadoIniciado = 'false';
      iniciarHeader(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wom-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarSlideshow(seccion) {
    if (seccion.dataset.banneSlideshowIniciado === 'true') return;
    seccion.dataset.banneSlideshowIniciado = 'true';

    var diapositivas = seccion.querySelectorAll('.banner-slideshow-diapositiva');
    var puntosPaginacion = seccion.querySelectorAll('.banner-slideshow-paginacion-item');
    var flechaAnterior = seccion.querySelector('.banner-slideshow-flecha--anterior');
    var flechaSiguiente = seccion.querySelector('.banner-slideshow-flecha--siguiente');

    if (diapositivas.length < 2) return;

    var indiceActual = 0;
    var autoplayActivo = seccion.dataset.autoplay === 'true';
    var velocidad = parseInt(seccion.dataset.velocidad, 10) || 5000;
    var pausarConHover = seccion.dataset.pausarHover === 'true';
    var intervalo = null;

    function mostrarDiapositiva(indice) {
      diapositivas.forEach(function (diapositiva, i) {
        var esActiva = i === indice;
        diapositiva.classList.toggle('banner-slideshow-diapositiva--activa', esActiva);
        diapositiva.setAttribute('aria-hidden', esActiva ? 'false' : 'true');
      });
      puntosPaginacion.forEach(function (punto, i) {
        punto.classList.toggle('banner-slideshow-paginacion-item--activo', i === indice);
      });
      indiceActual = indice;
    }

    function irASiguiente() {
      var siguiente = (indiceActual + 1) % diapositivas.length;
      mostrarDiapositiva(siguiente);
    }

    function irAAnterior() {
      var anterior = (indiceActual - 1 + diapositivas.length) % diapositivas.length;
      mostrarDiapositiva(anterior);
    }

    function iniciarAutoplay() {
      if (!autoplayActivo) return;
      detenerAutoplay();
      intervalo = setInterval(irASiguiente, velocidad);
    }

    function detenerAutoplay() {
      if (intervalo) {
        clearInterval(intervalo);
        intervalo = null;
      }
    }

    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        irASiguiente();
        iniciarAutoplay();
      });
    }

    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        irAAnterior();
        iniciarAutoplay();
      });
    }

    puntosPaginacion.forEach(function (punto) {
      punto.addEventListener('click', function () {
        var indice = parseInt(punto.dataset.indice, 10);
        mostrarDiapositiva(indice);
        iniciarAutoplay();
      });
    });

    if (pausarConHover) {
      seccion.addEventListener('mouseenter', detenerAutoplay);
      seccion.addEventListener('mouseleave', iniciarAutoplay);
    }

    var inicioX = 0;
    seccion.addEventListener('touchstart', function (evento) {
      inicioX = evento.touches[0].clientX;
    }, { passive: true });

    seccion.addEventListener('touchend', function (evento) {
      var finX = evento.changedTouches[0].clientX;
      var diferencia = inicioX - finX;
      if (Math.abs(diferencia) > 50) {
        if (diferencia > 0) {
          irASiguiente();
        } else {
          irAAnterior();
        }
        iniciarAutoplay();
      }
    }, { passive: true });

    mostrarDiapositiva(0);
    iniciarAutoplay();
  }

  function iniciarTodas() {
    document.querySelectorAll('.banner-slideshow-seccion').forEach(iniciarSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('.banner-slideshow-seccion');
    if (seccion) {
      seccion.dataset.banneSlideshowIniciado = 'false';
      iniciarSlideshow(seccion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
